import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import { stylingHelpers } from '../../designTokens';

const { textMega, textKilo, textGiga, resetList } = stylingHelpers;

const baseStyles = ({ theme }) => css`
  font-weight: ${theme.fontWeight.regular};
  margin-bottom: ${theme.spacings.mega};
`;

const sizeStyles = ({ theme, inline, size = 'mega' }) => {
  const sizeMap = {
    kilo: {
      marginBottom: theme.spacings.kilo,
      paddingLeft: theme.spacings.kilo,
      marginLeft: theme.spacings.bit,
      type: textKilo({ theme }),
    },
    mega: {
      marginBottom: theme.spacings.byte,
      paddingLeft: theme.spacings.kilo,
      marginLeft: theme.spacings.kilo,
      type: textMega({ theme }),
    },
    giga: {
      marginBottom: theme.spacings.kilo,
      paddingLeft: theme.spacings.mega,
      marginLeft: theme.spacings.kilo,
      type: textGiga({ theme }),
    },
  };

  const { marginBottom, paddingLeft, marginLeft, type } = sizeMap[size];

  return (
    !inline &&
    css`
      padding-left: ${paddingLeft};
      ${type};

      li {
        margin-bottom: ${marginBottom};
        margin-left: ${marginLeft};
      }

      ul,
      ol {
        margin-left: ${marginLeft};
      }
    `
  );
};

const marginStyles = ({ noMargin }) =>
  noMargin &&
  css`
    margin-bottom: 0;
  `;

const bulletStyles = ({ noBullets }) =>
  noBullets &&
  css`
    ${resetList()}
  `;

const inlineStyles = ({ inline }) =>
  inline &&
  css`
    display: flex;
    flex-wrap: wrap;
  `;

const BaseElement = styled('ol', {
  shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'size',
})`
  ${baseStyles};
  ${sizeStyles};
  ${marginStyles};
  ${bulletStyles}
  ${inlineStyles}
`;

const List = ({ variant, ...props }) => <BaseElement as={variant === 'ordered' ? 'ol' : 'ul'} {...props} />;

List.propTypes = {
  variant: PropTypes.string,
};

export default List;
